export enum Permission {
  RetailerCollections = 'retailer-collections',
  RetailerCollectionsRetailerCollectionsV2 = 'retailer_collections_retailer_collections.view',
  RetailerCollectionsV2Modify = 'retailer_collections.modify',
  Admin = 'admin_panel.legacy_permission',
  Flyers = 'flyers.view',
  FlyersAdmin = 'flyers_admin.view',
}
